import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

export function BackButton({ fallback = '/dashboard', testId = 'back-btn' }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <button
      onClick={handleBack}
      data-testid={testId}
      title="Retour à la page précédente"
      aria-label="Retour à la page précédente"
      className="p-2 hover:bg-[#F9F8F5] rounded-lg transition-all duration-200 text-[#5E6D66] hover:text-[#2D5A4C] hover:-translate-x-0.5 flex-shrink-0"
    >
      <ArrowLeft size={20} weight="bold" />
    </button>
  );
}
